import React, { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_BLOGS } from "../graphql/queries";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes/routes";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Bloghome() {
    const { loading, error, data } = useQuery(GET_BLOGS);
    const cardsRef = useRef([]);

    useEffect(() => {
        if (data) {
            setTimeout(() => {
                cardsRef.current.forEach((card, index) => {
                    gsap.from(card, {
                        opacity: 0,
                        y: 20,
                        duration: 0.8,
                        ease: "power3.out",
                        scrollTrigger: {
                            trigger: card,
                            start: "top 80%",
                        },
                    });
                });
            }, 100);
        }
    }, [data]);

    console.log({ loading, error, data });

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error : {error.message}</p>;
    }

    return (
        <div>
            <h1>Blog</h1>
            <div className="card-container">
                {data.blogs
                    .map((blog, index) => (
                        <Link
                            to={`${ROUTES.blog.path}/${blog.slug}`}
                            key={blog.id}
                            className="card"
                            ref={(el) => (cardsRef.current[index] = el)}
                        >
                            <img src={blog.image.url} alt={blog.title} />
                            <div className="card-content">
                                <h2>{blog.title}</h2>
                                <p className="card-description">
                                    {blog.description}
                                </p>
                                <p className="card-date">{blog.date}</p>
                            </div>
                        </Link>
                    ))
                    .slice(0, 4)}
            </div>
        </div>
    );
}
